import React from 'react';
import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '../data/blogData';
import SEO from '../components/SEO';
import './Blog.css';

function Blog() {
  return (
    <div className="blog-page">
      <SEO 
        title="Newspaper Advertising Blog - Tips & Guides"
        description="Read our latest guides on how to book newspaper ads, name change process, matrimonial ad tips, and more."
        url="/blog"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Blog', url: '/blog' }
        ]}
      />
      
      <section className="blog-hero">
        <div className="container">
          <h1>BookMyNewsAd Blog</h1>
          <p>Expert guides and tips for newspaper advertising in India</p>
        </div>
      </section>

      <section className="blog-list-section">
        <div className="container">
          <div className="blog-grid">
            {BLOG_POSTS.map(post => (
              <Link to={`/blog/${post.slug}`} key={post.id} className="blog-card">
                <div className="blog-image">
                  <img src={post.image} alt={post.title} />
                </div>
                <div className="blog-content">
                  <span className="blog-date">{post.date}</span>
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                  <span className="read-more">Read Article →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Blog;
